import { createFileRoute, useParams } from "@tanstack/react-router";
import { requireFeature } from "@/lib/feature-gate";
import { RequisitionDetailPage } from "@/components/inventory/RequisitionDetailPage";

export const Route = createFileRoute("/user/_layout/inventory/requisitions_/$id")({
  beforeLoad: () => requireFeature("inventory"),
  component: UserRequisitionDetail,
});

function UserRequisitionDetail() {
  const { id } = useParams({ from: "/user/_layout/inventory/requisitions_/$id" });
  return <RequisitionDetailPage reqId={id} userMode />;
}
